module.exports = __webpack_public_path__ + "img/startupValuationResult.11cb690e.png";